/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraMisConfigurationsTrendSummaryRequest extends models.InfraIssuesTimeRangeFilter {
    getFixupPrototypeFunction() { return InfraMisConfigurationsTrendSummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<InfraMisConfigurationsTrendSummaryRequest>): InfraMisConfigurationsTrendSummaryRequest {
        let obj = Object.assign(new InfraMisConfigurationsTrendSummaryRequest(), model);
        InfraMisConfigurationsTrendSummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraMisConfigurationsTrendSummaryRequest>): InfraMisConfigurationsTrendSummaryRequest {
        if (!model) return null;
        return InfraMisConfigurationsTrendSummaryRequest.newInstance(<InfraMisConfigurationsTrendSummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraMisConfigurationsTrendSummaryRequest) {
        if (!obj) return;

        models.InfraMisConfigurationsTrendSummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraMisConfigurationsTrendSummaryRequest): boolean {
        if (models.InfraIssuesTimeRangeFilter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraMisConfigurationsTrendSummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.SecurityInfraIssuesDashboardFilters.fixupPrototype(this.filters);
        }
    }

    /**
     * Fields to group the infrastructure misconfigurations results
     */
    group_by: Array<models.InfraMisConfigurationsTrendGroupBy>;

    /**
     * Filters applied to the issues trend data.
     */
    filters: models.SecurityInfraIssuesDashboardFilters;

}
